import { cn } from "@/lib/utils";

export function StatCard({
  label,
  value,
  hint,
  className,
}: {
  label: string;
  value: string | number;
  hint?: string;
  className?: string;
}) {
  return (
    <div className={cn("v2-panel v2-motion-card-stagger p-4", className)}>
      <p className="text-xs font-semibold uppercase tracking-wide text-[var(--v2-text-muted)]">
        {label}
      </p>
      <p className="v2-text-heading mt-1 text-2xl font-extrabold">{value}</p>
      {hint ? <p className="v2-text-body mt-1 text-xs">{hint}</p> : null}
    </div>
  );
}
